import { ReactComponent as PhoneIcon } from "../assets/icons/phone.svg";
import { ReactComponent as LocationIcon } from "../assets/icons/location.svg";
import { ReactComponent as ArrowIcon } from "../assets/icons/right-arrow.svg";
import { ReactComponent as BookingIcon } from "../assets/icons/booking.svg";
import { ReactComponent as MenuIcon } from "../assets/icons/menu.svg";
import { ReactComponent as CloseIcon } from "../assets/icons/close.svg";
import Label from "./Label";
import Button from "./Button";
import "../stylesheets/navbar.scss";
import { Link } from "react-router-dom";
import { handleRedirection, isAuthenticated } from "../services/utils";
import { useState } from "react";

// CONST

const phone: string = "07 69 54 87 12";
const adress: string = "5 Rue Damiette";
const maps =
	"https://www.google.com/maps/place/5+Rue+Damiette,+76000+Rouen/@49.43715,1.0947649,15.91z/data=!4m6!3m5!1s0x47e0de7f37ef3101:0x2436d4f931c96654!" +
	"8m2!3d49.4400855!4d1.097986!16s%2Fg%2F11q2vvy6qn?entry=ttu&g_ep=EgoyMDI1MDcyMy4wIKXMDSoASAFQAw%3D%3D";

// COMPONENT

function Navbar() {
	const [showMenu, setShowMenu] = useState<boolean>(false);

	return (
		<nav>
			<div className="left">
				<Link to="/">
					<img src="/assets/logo.png" alt="LE PETIT BAR" />
				</Link>
				<Label
					title={phone}
					subtitle="Nous Contacter"
					icon={<PhoneIcon />}
					onClick={() => handleRedirection("tel:" + phone.trim())}
				/>
				<Label
					title={adress}
					subtitle="76000 Rouen"
					icon={<LocationIcon />}
					onClick={() => handleRedirection(maps)}
				/>
				<MenuIcon
					className="menu-icon"
					onClick={() => setShowMenu(true)}
				/>

				<div className={`menu ${showMenu ? "slide-in" : "slide-out"}`}>
					<button onClick={() => setShowMenu(false)}>
						<CloseIcon />
					</button>
					<Link to="/">ACCUEIL</Link>
					<Link to="/menu">VOIR LA CARTE</Link>
					<Link to="/booking">RÉSERVER</Link>
					<Link to="/contact">CONTACTER</Link>
					<Link to="/events">ÉVÈNEMENTS</Link>
				</div>
			</div>
			<div className="right">
				<Button
					text="VOIR LA CARTE"
					icon={<ArrowIcon />}
					variant="filled"
					redirection="/menu"
				/>
				<Button
					text="RÉSERVER"
					icon={<BookingIcon />}
					variant="empty"
					redirection="/booking"
				/>
			</div>

			{isAuthenticated() && (
				<div className="edit-mode">
					<span>You are in edit mode !</span>
					<Link to="/login">logout</Link>
				</div>
			)}
		</nav>
	);
}

export default Navbar;
